import { UserPlus } from 'lucide-react';

interface ClientUsersProps {
  clientId: string;
}

export function ClientUsers({ clientId: _clientId }: ClientUsersProps) {
  // TODO: Implement user management
  // - Fetch users via GET /api/portal/clients/{id}/users
  // - Create user via POST /api/portal/clients/{id}/users
  // - Display user list with roles

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-slate-100">Users</h2>
          <p className="mt-1 text-sm text-slate-400">Manage client users and their roles</p>
        </div>
        <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 transition-all">
          <UserPlus className="h-4 w-4 mr-2" />
          Add User
        </button>
      </div>

      {/* Placeholder */}
      <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg border border-slate-700 p-12 text-center">
        <UserPlus className="mx-auto h-12 w-12 text-slate-600" />
        <h3 className="mt-2 text-sm font-semibold text-slate-300">User management coming soon</h3>
        <p className="mt-1 text-sm text-slate-500">
          This feature will be implemented in Phase 7
        </p>
      </div>
    </div>
  );
}
